import React from 'react';
import { Box, Container, Typography, Button, Card, CardContent } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function ErrorPage() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, rgba(255,165,0,0.08), rgba(0,0,0,0.02))',
                py: 6,
            }}
        >
            <Container maxWidth="sm">
                <Card
                    sx={{
                        borderRadius: 4,
                        textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.08)',
                        p: { xs: 3, md: 4 },
                    }}
                >
                    <CardContent>
                        <Typography variant="h2" color="error" fontWeight={700} gutterBottom>
                            500
                        </Typography>
                        <Typography variant="h5" gutterBottom>
                            Uups, da ist etwas schiefgelaufen
                        </Typography>
                        <Typography variant="body1" color="text.secondary" gutterBottom>
                            Entschuldigung, ein unerwarteter Fehler ist aufgetreten.
                            Bitte versuche es später erneut oder kontaktiere unseren Support.
                        </Typography>
                        <Button
                            component={RouterLink}
                            to="/"
                            variant="contained"
                            sx={{
                                mt: 3,
                                backgroundColor: 'orange',
                                '&:hover': { backgroundColor: '#cc7a00' },
                                borderRadius: 2,
                            }}
                        >
                            Zur Startseite
                        </Button>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
}
